import React, { useState } from 'react';

const SolutionsCard = () => {
  const [active, setActive] = useState('ManagedITServices');
  const [isHovered, setIsHovered] = useState(false);

  const content = {
    ManagedITServices: [
      // Network Switches
      {
        title: 'IT Solutions',
        models: [
          {
            description: 'Network Monitoring & Management',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Help Desk Support',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Cloud Services Management',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
      // Network Routers
      {
        title: 'IT Consulting Services',
        models: [
          {
            description: 'IT Strategy Development',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Technology Roadmap',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Business Continuity Planning',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
      // Network Firewalls
      {
        title: 'Networking & Connectivity',
        models: [
          {
            description: 'VPN Solutions',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Wi-Fi Solutions',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'WAN/LAN Solutions',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
    ],
    ITInfrastructureSolutions: [
      {
        title: 'Infrastructure Solutions',
        models: [
          {
            description: 'Network Design & Implementation',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Server Management',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Virtualization Solutions',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
    ],
    CloudSolutions: [
      {
        title: 'Our Cloud Solutions',
        models: [
          {
            description: 'Cloud Migration Services',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Hybrid Cloud Solutions',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Software as a Service (SaaS)',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
      {
        title: 'Backup and Disaster Recovery',
        models: [
          {
            description: 'Data Backup Solutions',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Disaster Recovery Planning',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Business Continuity Solutions',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
      {
        title: 'Storage Solutions',
        models: [
          {
            description: 'Amazon S3',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Microsoft Azure Blob Storage',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
    ],
    DataManagement: [
      {
        title: 'Data Management Solutions',
        models: [
          {
            description: 'Big Data Solutions',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Data Warehousing',
            link: {
              url: '/Solutions',
            },
          },
          {
            description: 'Business Intelligence (BI) Tools',
            link: {
              url: '/Solutions',
            },
          },
        ],
      },
    ],
  };

  const handleProductClick = (url) => {
    window.location.href = url; // Navigate to the product page
    window.close();             // Close the current window
  };

  return (
    <div className="relative group">
      <div 
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          className={`relative px-2 py-2 text-gray-600 bg-white rounded ease-in-out transform focus:outline-none font-normal 
            after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:transition-all after:duration-3000 
            ${isHovered ? 'hover:scale-110 after:bg-blue-500 after:w-full' : 'after:bg-transparent'}`}
        >
          Solutions
        </button>
        <div className="fixed left-1/2 transform -translate-x-1/2 mt-0.5 bg-white rounded-md hidden group-hover:block text-justify w-full sm:w-11/12 lg:max-w-1200px z-50 overflow-y-auto max-h-[80vh]">
          <div className="p-4 flex flex-col lg:flex-row text-justify h-auto lg:h-68vh">
            {/* Options on the left */}
            <div className="flex-shrink-0 mt-8 flex lg:flex-col overflow-x-auto lg:overflow-visible">
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] font-normal ${active === 'ManagedITServices' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('ManagedITServices')}
              >
                Managed IT Services
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'ITInfrastructureSolutions' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('ITInfrastructureSolutions')}
              >
                IT Infrastructure Solutions
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'CloudSolutions' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('CloudSolutions')}
              >
                Cloud Solutions
              </button>
              <button
                className={`block px-4 py-2 text-gray-800 hover:bg-[#f2f3f4] hover:text-blue-900 font-normal ${active === 'DataManagement' ? 'bg-[#f2f3f4]' : 'text-blue-900'}`}
                onClick={() => setActive('DataManagement')}
              >
               Data Management & Analytics
              </button>
            </div>
            {/* Vertical rule */}
            <div className="border-l border-gray-300 h-auto mx-4 hidden lg:block"></div>
            {/* Content on the right */}
            <div className="flex-grow p-4 overflow-x-auto lg:overflow-visible">
              <div className="flex flex-wrap lg:flex-nowrap lg:space-x-4">
                {content[active].map((item, index) => (
                  <div key={index} className="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 bg-white rounded-lg overflow-hidden shadow-lg mb-4">
                    <div className="p-4">
                      <h3 className="text-lg text-gray-600 font-normal">{item.title}</h3>
                      <hr /> <br />
                      {item.models.map((model, idx) => (
                        <div key={idx} className="mb-2">
                          <p
                            onClick={() => handleProductClick(model.link.url)}
                            className="text-gray-500 hover:text-blue-900 text-sm font-normal cursor-pointer"
                          >
                            {model.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsCard;
